<template>
    <b-row>
        <b-col cols="12">
            <LinkStyleGuide @open-url="openActivity()"
                            icon-name="icon-link"
                            :text="title"></LinkStyleGuide>
        </b-col>
    </b-row>
</template>

<script>
    import {Activity} from '../../core/Utils'
    import LinkStyleGuide from "../../core/Components/LinkStyleGuide"

    export default {
        name: "ProjectStepActivity",
        components: {LinkStyleGuide},
        props: {
            url: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            }
        },
        methods: {
            openActivity() {
                Activity.open(this.url, this.title, this.$route.params.index, this.$route.path, this.$route.name)
            }
        }
    }
</script>